import Appeal from '@components/LocalMerchant/Appraise/Appeal'

export default {
  path: 'Appeal(/:id)',
  component: Appeal,
  stat: '申诉/首页'
}
